import { SapJaws, SapDocumentStatus, SapTransportationCode } from "libs/sap/src/lib/models/sap.model";
import { MinimalQuotationDocumentLine, MinimalQuotation } from "./sap.minimal-quotation.interface";

export enum SapQuotationViewType {
	TMAdmin = "tmadmin"
}

export interface AdminPreviewQuotation extends MinimalQuotation {
	DocEntry: number;
	DocNum: number;
	DocumentLines: AdminPreviewQuotationDocumentLine[];
	DocumentStatus: SapDocumentStatus;
	U_CADDAAN?: string; // Data retrieved
	U_CADKIBE?: SapJaws; // Jaw infomration
	U_CADBEFI?: string; // Benefit
	U_CADREKL?: string; // Complaint
	U_CADREBE?: string; // Complaint eligible
	U_CADTMBH?: string; // Order comment
	TransportationCode?: SapTransportationCode;
}

export interface AdminPreviewQuotationDocumentLine extends MinimalQuotationDocumentLine {
	ItemCode: string;
	ItemDescription: string;
	Quantity: number;
	Price: number;
	UnitPrice: number;
	DiscountPercent: number;
	RemainingOpenQuantity: number;
	U_CADKIEFE: SapJaws;  // Jaw information
	U_CADZABE: string;  // Tootharea
	U_CADBEFI: string; // Benefit
	U_CADSTEP?: string; // Steps
	FreeText: string;
}
